export default __webpack_public_path__ + "static/media/facebook.5b5832e5.svg";